var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_light_theme)?_c('img',{attrs:{"src":_vm.light_img,"alt":""}}):_c('img',{attrs:{"src":_vm.dark_img,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }